( function ( $ ) {

  let breakpoints_obj = GeoInteractiveMap.CONTAINER_SIZES;

  // JS objects cannot be relied on for ordering
  // rebuild into array of objects and sort
  let breakpoints = [];
  $.each( breakpoints_obj, function ( size, px ) {
    breakpoints.push({ size, px });
  });
  breakpoints.sort( function( a, b ) {
    return a.px - b.px;
  });


  const observer = new ResizeObserver( entries => {
    for ( let entry of entries ) {
      const args = { bp: 'xs' };
      breakpoints.forEach( bp => {
        if ( entry.borderBoxSize[0].inlineSize >= bp.px ) {
          args.bp = bp.size;
        }
      });
      $( entry.target ).trigger( 'set-container-bp', args ).attr( 'data-con-bp', args.bp );
    }
  });


  function init () {
    $( '.gim-container' ).not( '[data-con-bp]' ).each( function () {
      observer.observe( this );
    });
  }

  // trigger init
  $( init );

})( jQuery );